import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

export interface ApiError extends AxiosError {
    response?: AxiosResponse;
    config: InternalAxiosRequestConfig;
}

export interface ApiConfig extends InternalAxiosRequestConfig {
    _retry?: boolean;
    loadingMessage?: string;
}

export enum HttpStatusCode {
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_SERVER = 500,
}

export const API_CONSTANTS = {
    PLATFORM_ACCESS: 'web',
    TOKEN_KEY: 'auth_token',
    BASE_URL: process.env.VUE_APP_API_URL || '',
    API_KEY: process.env.VUE_APP_API_KEY || '',
    REVERB_KEY: process.env.VUE_APP_REVERB_KEY || '',
    REVERB_HOST: process.env.VUE_APP_REVERB_HOST || '',
    REVERB_PORT: Number(process.env.VUE_APP_REVERB_PORT) || 8080,
} as const;
